import _ from 'lodash'

export default {
	name : 'select-field',
	props : ['data'],
	data () {
		return {
			field : {
				fakeValue : this.data.fakeValue,
				value : this.data.value,
				active : false
			}
		}
	},
	methods : {
		changeData (option) {

			let vm = this

			vm.field.fakeValue = option.fakeValue
			vm.field.value     = option.value
			vm.field.active    = false

			this.$emit('changeData', option.value);

		}
	}
}


// WEBPACK FOOTER //
// ./src/components/general/fields/select/script.js